// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"style_leftButton___-7em","rightButton":"style_rightButton__2trM5","active":"style_active__1pmhR","bellShake":"style_bellShake__30smG"};